import React, { useRef } from "react";
import { FaCoins, FaGear, FaInfo, FaRepeat } from "react-icons/fa6";
import { closeModal, openModal } from "../../../State/Slices/modalSlice";
import { useDispatch, useSelector } from "react-redux";
import styles from "../../../Styles/Modules/ControlPanel.module.scss";
import Button from "../../../Elements/Button/Button";
import SettingsModal from "../../Modals/SettingsModal";
import InfoModal from "../../Modals/InfoModal";
import BetsModal from "../../Modals/BetsModal";
import Display from "../../../Elements/Display/Display";
import SessionModal from "../../Modals/SessionModal";
import IntroModal from "../../Modals/IntroModal";
import ButtonPlay from "../ButtonPlay/ButtonPlay";
import CreditModal from "../../Modals/CreditModal";
import AutoPlayModal from "../../Modals/AutoPlayModal";
import BalanceCounter from "../BalanceCounter/BalanceCounter";
import ButtonFreeSpinStart from "../ButtonFreeSpinStart/ButtonFreeSpinStart";

const ControlPanelMain = ({
  handleSpin,
  handleStop,
  handleFreeSpin,
  handleFreeSpinStop,
}) => {
  const displayRef = useRef();

  const dispatch = useDispatch();
  const { balance, bet } = useSelector((state) => state.game);
  const { isSpinning, spinComplete } = useSelector((state) => state.spin);
  const { remainingAutoSpins, autoPlayActive } = useSelector(
    (state) => state.settings
  );
  const { freeSpinIntroAnimationStarted, freeSpinOutroAnimationStarted } =
    useSelector((state) => state.animations);
  const { isFreeSpinMode } = useSelector((state) => state.freeSpins);

  return (
    <div
      className={styles.userInterface}
      onClick={() => dispatch(closeModal())}
    >
      <div
        className={styles.userInterfaceControls}
        onClick={(e) => e.stopPropagation()}
      >
        <div className={styles.userInterfaceControlsLeft}>
          <div className={styles.userInterfaceControlsLeftContainer}>
            <SessionModal />

            <Button
              action={() => openModal("settings")}
              title="settings"
              icon={FaGear}
              disabled={isSpinning && !spinComplete}
              modifier="buttonSettings"
            />

            <Button
              action={() => openModal("info")}
              title="info"
              icon={FaInfo}
              disabled={isSpinning && !spinComplete}
              modifier="buttonInfo"
            />
          </div>

          <div className={styles.userInterfaceControlsLeftContainer}>
            <Display label="bet" value={bet} modifier="displayBet" />

            <BalanceCounter value={balance} />
          </div>
        </div>

        <div className={styles.userInterfaceControlsRight}>
          {!isFreeSpinMode && (
            <Button
              action={autoPlayActive ? undefined : () => openModal("autoPlay")}
              title="autoplay"
              icon={!autoPlayActive && FaRepeat}
              text={autoPlayActive ? remainingAutoSpins : ""}
              disabled={!autoPlayActive && !isSpinning && !spinComplete}
              modifier="buttonAutoPlay"
            />
          )}

          {!isFreeSpinMode && (
            <ButtonPlay
              handleSpin={handleSpin}
              handleStop={handleStop}
              displayRef={displayRef}
            />
          )}

          {isFreeSpinMode &&
            (freeSpinIntroAnimationStarted ||
              freeSpinOutroAnimationStarted) && (
              <ButtonFreeSpinStart
                handleFreeSpin={handleFreeSpin}
                handleFreeSpinStop={handleFreeSpinStop}
              />
            )}

          {/* {isFreeSpinMode &&
            freeSpinIntroAnimationCompleted &&
            !freeSpinOutroAnimationStarted && (
              <ButtonFreeSpinPlay
                handleFreeSpin={handleFreeSpin}
                handleFreeSpinStop={handleFreeSpinStop}
              />
            )} */}

          {!isFreeSpinMode && (
            <Button
              action={() => openModal("bets")}
              title="bet"
              icon={FaCoins}
              disabled={isSpinning && !spinComplete}
              modifier="buttonBet"
            />
          )}
        </div>
      </div>

      <div onClick={(e) => e.stopPropagation()}>
        <CreditModal />
        <SessionModal />
        <SettingsModal />
        <InfoModal />
        <AutoPlayModal />
        <BetsModal />
        <IntroModal />
      </div>
    </div>
  );
};

export default ControlPanelMain;
